import axios from 'axios'

let apiRoot = 'https://api.diquex.thiagosf.net'
if (process.env.NODE_ENV === 'development') {
  apiRoot = 'http://diquex-api.dev.azk.io'
}

const onSuccess = (response) => {
  return response.data
}

const onError = (error) => {
  let message = 'Unknown error'
  if (error.response && error.response.data) {
    message = error.response.data.message || error.response.data.exception || error.response.data.error
  } else {
    console.log('error', error)
  }
  throw new Error(message)
}

export default {
  instance (headers = {}) {
    return axios.create({
      baseURL: apiRoot,
      timeout: 15000,
      headers
    })
  },
  get (path, options, headers = {}) {
    return this.instance(headers).get(path, options)
      .then(onSuccess)
      .catch(onError)
  },
  post (path, options, headers = {}) {
    return this.instance(headers).post(path, options)
      .then(onSuccess)
      .catch(onError)
  },
  put (path, options, headers = {}) {
    return this.instance(headers).put(path, options)
      .then(onSuccess)
      .catch(onError)
  },
  delete (path, options, headers = {}) {
    return this.instance(headers).delete(path, options)
      .then(onSuccess)
      .catch(onError)
  },
  headersWithToken (rootGetters) {
    let headers = {}
    let user = rootGetters.getUser
    if (user) {
      let token = user.token
      headers = {
        'X-API-Auth-Token': token
      }
    }
    return headers
  }
}



// WEBPACK FOOTER //
// ./src/helpers/request_utils.js